import { AppointmentWidget } from "../../components/widgets";
import { ProfileRole } from "../../store/profile/profileSlice";

const TutorTab = ({ profile }) => {
    if (!profile?._id) return null;
    const role =
        profile.role === ProfileRole.TUTOR || profile.role === 2 || profile.role === "2"
            ? ProfileRole.TUTOR
            : profile.role;
    return <AppointmentWidget profile={profile._id} role={role} />;
};

export { TutorTab };